<template>

			<div class="mzixunWrap">
				<div class="mzixunLeft white">
					<div class="abstractIitem">
						<div class="itemTile">
							<h3>校园环境</h3>
						</div>
						<div class="plr20">
							<div class="huanItem">
								<div class="huanSwiper huanjing">
									<!-- Swiper -->
									<div class="swiper-container">
										<div class="swiper-wrapper">
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div>
														<div class="icon"><img src="../../images/3259.png"></div>
														<span>VR全景地图</span>
													</div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div>
														<div class="icon"><img src="../../images/3259.png"></div>
														<span>VR全景地图</span>
													</div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div>
														<div class="icon"><img src="../../images/3259.png"></div>
														<span>VR全景地图</span>
													</div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div>
														<div class="icon"><img src="../../images/3259.png"></div>
														<span>VR全景地图</span>
													</div>
												</router-link>
											</div>
										</div>
									</div>
									<!-- Add Arrows -->
									<div class="swiper-button-next"></div>
									<div class="swiper-button-prev"></div>

								</div>
							</div>
						</div>
					</div>
					<div class="abstractIitem">
						<div class="itemTile">
							<h3>文化生活</h3>
						</div>
						<div class="plr20">
							<div class="huanItem">
								<div class="huanSwiper wenhua">
									<!-- Swiper -->
									<div class="swiper-container">
										<div class="swiper-wrapper">
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div>
														<div class="icon"><img src="../../images/3259.png"></div>
														<span>VR全景地图</span>
													</div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div>
														<div class="icon"><img src="../../images/3259.png"></div>
														<span>VR全景地图</span>
													</div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div>
														<div class="icon"><img src="../../images/3259.png"></div>
														<span>VR全景地图</span>
													</div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div>
														<div class="icon"><img src="../../images/3259.png"></div>
														<span>VR全景地图</span>
													</div>
												</router-link>
											</div>
										</div>
									</div>
									<!-- Add Arrows -->
									<div class="swiper-button-next"></div>
									<div class="swiper-button-prev"></div>
								</div>
							</div>
						</div>
					</div>

					<div class="abstractIitem">
						<div class="itemTile">
							<h3>食宿条件</h3>
						</div>
						<div class="plr20">
							<div class="huanItem">
								<div class="huanSwiper shisu">
									<!-- Swiper -->
									<div class="swiper-container">
										<div class="swiper-wrapper">
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div class="open">查看全部<i></i></div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div class="open">查看全部<i></i></div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div class="open">查看全部<i></i></div>
												</router-link>
											</div>
											<div class="swiper-slide">
												<img src="../../images/img03.png">
												<router-link to="/xyzy_xioayuanshenghuoxq" class="swiperShow">
													<div class="open">查看全部<i></i></div>
												</router-link>
											</div>
										</div>
									</div>
									<!-- Add Arrows -->
									<div class="swiper-button-next"></div>
									<div class="swiper-button-prev"></div>
								</div>
							</div>
						</div>
					</div>

				</div>

				<div class="abstractRight white">
					<div class="abstractIitem">
						<div class="itemTile">
							<h3>校园概况</h3>
						</div>
						<ul class="gaikuang">
							<li>
								<p>综合评分：<span>4.8</span>分</p>
							</li>
							<li>
								<p>生活环境：<span>4.9</span>分</p>
							</li>
							<li>
								<p>学习氛围：<span>4.8</span>分</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		
</template>

<script>
	import vHeader from '../../../components/vHeader.vue'
	import zuoxuanfu1 from '../../../components/zuoxuanfu1.vue'
	import item7 from '../../../components/item7.vue'
	import "../../js/swiper-bundle.min.js"
	import "../../css/swiper-bundle.min.css"
	export default {
		name: "",
		components: {
			vHeader,
			item7,
			zuoxuanfu1
		},
		data() {
			return {
				// 导航选中
				Name:2,
			}
		},
		mounted(){
			this.lun1()
			this.lun2()
			this.lun3()

		},
		methods: {
			lun1(){
				var swiper = new Swiper('.huanjing .swiper-container', {
				  slidesPerView:'auto',
				  spaceBetween: 17,
				  loop: true,
				  navigation: {
					nextEl: '.huanjing .swiper-button-next',
					prevEl: '.huanjing .swiper-button-prev',
				  },
				});
			},
			lun2(){
				var swiper = new Swiper('.wenhua .swiper-container', {
				  slidesPerView:'auto',
				  spaceBetween: 17,
				  loop: true,
				  navigation: {
					nextEl: '.wenhua .swiper-button-next',
					prevEl: '.wenhua .swiper-button-prev',
				  },
				});
			},
			lun3(){
				var swiper = new Swiper('.shisu .swiper-container', {
				  slidesPerView:'auto',
				  spaceBetween: 17,
				  loop: true,
				  navigation: {
					nextEl: '.shisu .swiper-button-next',
					prevEl: '.shisu .swiper-button-prev',
				  },
				});
			},
		}


	}
</script>

<style scoped>
	.wrap{background: #FBFBFB;}
	/* 右边固定 */
	.zuotab{height: auto; display: flex;flex-direction: column;position: fixed;top: 50%;right: 0px;transform:translate(-50%,-50%);}
	.zuotab figure{cursor: pointer; margin: 8px 0; width: 64px;height: 62px;border: 1px solid #FF0000;border-radius: 5px;display: flex;flex-direction: column; align-items: center;justify-content: center;}
	.zuotab figure img{width: 20px;height: 20px;}
	.zuotab figure figcaption{font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;margin-top: 10px;}

</style>



// WEBPACK FOOTER //
// src/views/information/collegeinfo/xyzy_xioayuanshenghuo.vue